import React from 'react';
import { Box, Typography, Grid } from '@material-ui/core';

import EscolhaData from '../childrens/escolhaData/.mixins';
import EscolhaFilial from '../childrens/escolhaFilial/.mixins';
import EscolhaCondicao from '../childrens/escolhaCondicao/.mixins';
import EscolhaSituacao from '../childrens/filter/.mixins';
import { OpcoesGrupo } from '../childrens/OpcoesGrupo/.mixins';
import { OpcoesFamilia } from '../childrens/opcoesFamilia/.mixins';

import OpcoesBusca from '../../../../opcoesBusca/.mixins';
import OpcoesBuscaTags from '../../../../opcoesBuscaTags/.mixins';
import CalendarRange from '../../../../calendarRange/.mixins';

//css
import StylesCss from './styles';
const useStyles = StylesCss();

export default (props) => {
    const classes = useStyles();
    return (
        <>
            {props.colunasFilterTags != null &&
                <OpcoesBuscaTags {...props}/>
            }
            {props.searchField != null &&
                <>
                    <Typography className={classes.titlePopover}>
                        {props.searchBarTitle ? props.searchBarTitle : "Pedido / Produto"}
                    </Typography>
                    <OpcoesBusca {...props}/>
                    <br/><br/>
                </>
            }
            {props.dtInitial != null &&
                <>
                    {!props.isFixed &&
                        <Typography className={classes.titlePopover}>
                            Data
                        </Typography>
                    }
                    {props.isFixed &&
                        <Typography className={classes.titlePopover}>
                            {props.escolhaData}
                        </Typography>
                    }
                    <CalendarRange {...props}/>
                    <br/>
                    {!props.isFixed &&
                        <EscolhaData {...props}/>
                    }
                    <br/><br/>
                </>
            }

            <Grid container spacing={2}>
                <Grid item xs={6}>
                    {props.escolhaFilial != null &&
                        <EscolhaFilial {...{...props,width:"100%"}}/>
                    }
                </Grid>
                <Grid item xs={6}>
                    {props.escolhaCondicao != null &&
                        <EscolhaCondicao {...{...props,width:"100%"}}/>
                    }
                </Grid>
            </Grid>

            <Box>
                {props.escolhaGrupo != null && (
                    <OpcoesGrupo
                        grupos={props.opcoesGrupos}
                        escolhaGrupo={props.escolhaGrupo}
                        handleChangeGrupos={props.handleChangeGrupos}
                    />
                )}
            </Box>

            <Box marginY="20px">
                {props.escolhaFamilia != null && (
                    <OpcoesFamilia
                        familias={props.opcoesFamilias}
                        escolhaFamilia={props.escolhaFamilia}
                        handleChangeFamilias={props.handleChangeFamilias}
                        isSelectFamiliasDisabled={props.escolhaGrupo == 0}
                    />
                )}
            </Box>

            
            {props.escolhaSituacao != null &&
                <EscolhaSituacao {...props}/>
            }
        </>
    );
};